import { Component, computed, input, linkedSignal, output } from '@angular/core';
import { IMultiProductCard } from '@mwe/models';
import { isArrayWithOneItem } from '@mwe/utils';
import { ISliderResponse, ProductCardSliderComponent } from '../product-card-slider/product-card-slider.component';
import { NgClass } from '@angular/common';
import { MultiProductCardComponent } from './multi-product-card.component';
import { CardSelectableComponent } from '../../cards/card-selectable/card-selectable.component';
import { ProductIconComponent } from '../../product-icon/product-icon.component';
import { CorrelatedCompanyReferencePipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-multi-product-card-container',
  templateUrl: './multi-product-card-container.component.html',
  imports: [
    MultiProductCardComponent,
    NgClass,
    ProductCardSliderComponent,
    CardSelectableComponent,
    ProductIconComponent,
    CorrelatedCompanyReferencePipe,
  ],
})
export class MultiProductCardContainerComponent {
  isSliderVisible = input(true);
  multiProductCards = input<IMultiProductCard[]>([]);
  isDisabled = input(false);
  showCompanyReference = input(false);
  showSummarizedCompanyReference = input(false);
  showAccountNumber = input(false);
  showCustomerNumber = input(false);
  hasMousePointerStyle = input(false);

  // MWE-15797
  useSelectableCards = input(false);
  handleSelectedIds = output<string[]>();
  cardClicked = output<IMultiProductCard>();
  showSlider = computed(() => {
    if (isArrayWithOneItem(this.multiProductCards())) {
      return false;
    }
    return this.isSliderVisible();
  });
  isOnlyOneVk = computed(() => {
    return this.isDisabled() || !this.showSlider();
  });
  selectedIds = linkedSignal(() => this.multiProductCards().map(mpc => mpc.id));

  handleSliderResponse(response: ISliderResponse): void {
    this.selectedIds.set(
      response.checked ? [...this.selectedIds(), response.id] : this.selectedIds().filter(accountNr => accountNr !== response.id),
    );
    this.handleSelectedIds.emit(this.selectedIds());
  }
}
